import { graphql } from 'react-relay';

export const iconLinkFragment = graphql`
    fragment IconLink_iconLink on IconLink {
        label
        iconUrl
        url
    }
`;
